/**
 * Chip — atom (CES standard)
 * Small pill label: instance pools, families, and empty placeholders.
 * Light-theme look aligned with the client portal's badges.
 */

import type { ReactNode } from 'react';

const VARIANT_CLASSES = {
  default: 'bg-gray-100 border-gray-200 text-gray-700',
  family: 'bg-orange-50 border-orange-300 text-orange-700',
  empty: 'bg-transparent border-dashed border-gray-300 text-gray-400',
} as const;

export function Chip({
  variant = 'default',
  children,
}: {
  variant?: keyof typeof VARIANT_CLASSES;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-block rounded-full border px-3 py-1 text-xs whitespace-nowrap ${VARIANT_CLASSES[variant]}`}
    >
      {children}
    </span>
  );
}
